<script>
  // Routing

  // Options
  export let size = "xl";
</script>

<!-- Markup -->
<div>

  <a class="uppercase
            text-{ size }
            text-slate
            hover:text-silver
            transition-colors
            duration-200
            outline-none
            dark:text-silver
            dark-hover:text-teal"
     href="/">


    <span class="font-light">sun</span><span>&</span><span class="font-light">colors</span>

  </a>
</div>
